export default __webpack_public_path__ + "static/media/logo.efe75110.svg";